<template>
    <div class="enc">
        <div class="nav">
            <img src="../../public/images/NaecLogo.png"/>
        </div>
        <div class="selectorContainer">
            <selector></selector>
        </div>
    </div>


</template>

<script>
    // @ is an alias to /src

    import selector from '../components/selector.vue'

    export default {
        name: 'home',
        components: {

            selector,
        }
    }
</script>

<style scoped>
    .enc{
        text-align: center;
    }
    .nav {
        padding: 10px;
        width: 90%;
        margin: 0 auto;
    }

    .nav img {
        max-width: 500px;
        width: 100%;
    }

    .selectorContainer {
        background-color: #F1F1F1;
        padding: 10px;
        min-height: 70vh;
    }

</style>
